import { render, staticRenderFns } from "./journeyStats.vue?vue&type=template&id=6474081d&"
import script from "./journeyStats.vue?vue&type=script&lang=js&"
export * from "./journeyStats.vue?vue&type=script&lang=js&"
import style0 from "./journeyStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports